<template>
    <div class="loginPage">
        <div class="loginMain">
            <div class="loginTitle">大气污染成因分析系统-专业版</div>
            <div class="loginType">
                <div class="item" v-for="(item,index) in loginTypeList"
                     :class="{active:index===loginType}"
                     @click="loginChange(index)"
                     :key="index">{{item}}</div>
            </div>
            <div class="weichatBox" id="weichatBox" v-if="loginType===0">

            </div>
            <div v-if="loginType===1">
                <el-form
                        :model="dataForm"
                        :rules="dataRule"
                        ref="dataForm"
                        class="login-form"
                        @keyup.enter.native="dataFormSubmit()"
                        status-icon>
                    <!--                <div class="center">-->
                    <el-form-item prop="phone">
                        <div class="form-item">
                               <span class="icon">
                                    <img  src="../assets/md-person.svg" alt="">
                                </span>
                            <el-input v-model="dataForm.phone" placeholder="帐号"></el-input>
                        </div>
                    </el-form-item>
                    <el-form-item prop="password">
                        <div class="form-item">
                                <span class="icon">
                                    <img src="../assets/md-pwd.svg" alt="">
                                </span>
                            <el-input v-model="dataForm.password" type="password" placeholder="密码"></el-input>
                        </div>
                    </el-form-item>

<!--                    <el-form-item>-->
<!--                        <div id="captcha-div"></div>-->
<!--                    </el-form-item>-->

                    <el-form-item class="login-btn">
                        <el-button class="login-btn-submit" type="primary" @click="dataFormSubmit()">登录</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <el-dialog
                :visible.sync="captchaOpen"
                append-to-body
                custom-class="captchaDialog"
                width="320px"
                :before-close="handleClose"
                >

            <div id="captcha-div"></div>
        </el-dialog>

    </div>
</template>

<script>
    import {getUUID} from '@/utils'
    import url from "@/utils/UrlApi"
    import Cookie from "js-cookie";
    import "@/assets/captcha/styles/tac.css" // 验证码css
    import "@/assets/captcha/tac.min.js"; // 验证码js


    let captcha;

    export default {
        name: "login",
        data(){
            return {
                loginTypeList:[
                    '扫码登录',
                    '帐号登录',
                ],
                loginType:0,
                dataRule:{
                    phone: [
                        {required: true, message: '帐号不能为空', trigger: 'blur'}
                    ],
                    password: [
                        {required: true, message: '密码不能为空', trigger: 'blur'}
                    ],
                },
                dataForm:{
                    phone:'',
                    password:'',
                },
                captchaOpen:false
            }
        },
        mounted() {
            this.getWeichatCode()
        },
        computed: {
            userName: {
                get() {
                    return this.$store.getters.getUserName;
                },
                set(val) {
                    this.$store.commit("updateUserName",val);
                }
            },
            userType: {
                get() {
                    return this.$store.state.userType;
                },
                set(val) {
                    this.$store.commit("updateUserType", val);
                }
            },
        },
        methods: {


            loginChange(type){
                this.loginType = type
                if (type===0){
                    this.$nextTick(()=>{
                        this.getWeichatCode()
                    })
                }
            },
            getWeichatCode() {

                //     清除登录信息
                Cookie.remove("BSG-userInfo");

                localStorage.removeItem('token')
                localStorage.removeItem('userName')


                let uuid = getUUID()
                // console.log(url.wxCheck)

                let obj = new WxLogin({
                    self_redirect: false,
                    id: "weichatBox",
                    appid: "wxe8f2e45831cd4f62",   // 正式版
                    // appid: "wx0e419dff3a1fde37",  //  测试版
                    scope: "snsapi_login",
                    redirect_uri: url.wxCheck,
                    state: uuid,
                    style: "",
                    href: ""
                });
                // // console.log(url.wxLogin)
            },
            dataFormSubmit() {

                let self = this
                this.$refs['dataForm'].validate((valid) => {
                    if (valid) {


                        self.captchaOpen = true

                        self.$nextTick(()=>{
                            self.login()
                        })


                    }
                })

                // this.$router.push({
                //     name:'AirQuality'
                // })
            },
            login(){
                let self = this
                let style = {
                    logoUrl: null,
                    height:500,
                    width:500
                }


                const encodedPassword = encodeURIComponent(self.dataForm.password);
                const encodedPhone = encodeURIComponent(self.dataForm.phone);


                const config = {
                    requestCaptchaDataUrl: url.captcha,
                    validCaptchaUrl: url.webLogin+'?phone='+encodedPhone+'&password='+encodedPassword,
                    bindEl: "#captcha-div",
                    // 验证成功回调函数
                    validSuccess:(res,c,tac)=> {

                        self.captchaOpen = false


                        if (res.code === '200') {
                            localStorage.setItem('token', res.data.token)
                            localStorage.setItem('userName', res.data.userInfo.name)
                            localStorage.setItem('userId', res.data.userInfo.userId)
                            self.userName = res.data.userInfo.name
                            self.$router.push({
                                name:'systemSelection'
                            })
                        } else {
                            self.$message.error(res.message)
                        }

                        tac.destroyWindow();

                    },
                    validFail: (res, c, tac) => {
                        // 验证失败后重新拉取验证码
                        console.log('-------error------')
                        console.log(res)

                       if (res.code==='555') {
                            tac.reloadCaptcha();
                        }else {
                            self.captchaOpen = false
                            self.$message.error(res.message)

                            tac.destroyWindow();
                        }

                    }
                }
                captcha =  new window.TAC(config,style).init();

            },

            handleClose(done) {
                this.$confirm('确认关闭？')
                    .then(_ => {
                        console.log(captcha)
                        captcha.destroyWindow();
                        done();
                    })
                    .catch(_ => {});
            }
        }
    }
</script>

<style scoped lang="less">

    .loginPage {
        position: absolute;
        left: 0;
        top: 0;
        z-index: 100;
        height: 100%;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        background-image: url("../assets/images/loginBJ2.jpg");
        background-size: 100% 100%;
        background-repeat: no-repeat;
        .loginMain {
            text-align: center;
            width: 600px;
            /*height: 500px;*/
            background-color: rgba(255, 255, 255, .6);
            border-radius: 20px;
            padding: 10px;
            display: flex;
            flex-direction: column;
            .loginTitle {
                font-size: 20px;
                font-weight: bold;
            }
            .loginType{
                display: flex;
                align-items: center;
                justify-content: center;
                border-bottom: 1px solid #ddd;
                padding: 10px 0;
                .item{
                    width: 100px;
                    text-align: center;
                    cursor: pointer;
                }
                .active{
                    color: #409EFF;
                }
            }
            .weichatBox {
                flex: 1;
            }
            .formBox {
                flex: 1;
            }
        }


        .login-form{
            padding: 70px 80px;
            .form-item{
                display: flex;
                align-items: center;
                .icon{
                    padding: 0 10px;
                    margin-right: 10px;
                    position: relative;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    &:after{
                        content: '';
                        position: absolute;
                        width: 2px;
                        height: 20px;
                        top: 50%;
                        right: 0;
                        margin-top: -10px;
                        background-color: #3A62D7;
                    }
                    img{
                        width: 25px;
                        height: 25px;
                        color: #3A62D7;
                    }
                    svg{
                        width: 25px;
                        height: 25px;
                        font-weight: bold;
                    }
                }
            }
            .login-btn {
                width: 100%;
                text-align: center;
                .login-btn-submit{
                    margin-top: 10px;
                    width: 100%;
                    background-color: #3A62D7;
                }
            }
        }
    }

    #captcha-div {
        /*position: absolute;*/
        /*top: -300px;*/
        /*left: -50px;*/
        display: flex;
        justify-content: center;
        align-items: center;
    }

    /deep/  .captchaDialog{
        padding: 10px;
        .el-dialog__body{
            padding: 0;
        }
        .el-dialog__header{
            padding: 0;
        }
    }

  /*  /deep/ #tianai-captcha-parent{
        width: 600px;
        height: 600px;
    }*/
</style>
